<template>
  <b-form-group :class="bv_class">
    <label :for="v_model" v-if="!show_um_label">
      {{input_text}} <span v-if="required" style="color: red; padding-right: 0.5em">(*)</span>
      <b-form-checkbox v-model="input.model_range"
                       class="float-right"
                       v-b-tooltip.top.hover="'Rango de valores'"
                       :value="1"
                       :unchecked-value="0"
                       v-show="!disabled_range"
                       @change="rangoValores()"
                       :disabled="readonly" />
    </label>
    <b-row>
      <b-col>
        <label :for="v_model" v-if="show_um_label">
          {{input_text}} <span v-if="required" style="color: red; padding-right: 0.5em">(*)</span>
          <b-form-checkbox v-model="input.model_range"
                           class="float-right"
                           v-b-tooltip.top.hover="'Rango de valores'"
                           :value="1"
                           :unchecked-value="0"
                           v-show="!disabled_range"
                           @change="rangoValores()"
                           :disabled="readonly" />
        </label>
        <b-form-input :id="v_model"
                      :name="v_model"
                      type="number"
                      step="0.001"
                      :required="required"
                      v-model="input.model_from"
                      data-vv-as=" "
                      @change="vModelVal()"
                      v-validate="{
                  rules: {
                    required: true,
                    decimal: 3,
                    min_value: 0
                  }
                }"
        />
      </b-col>
      <b-col cols="1"
             v-if="input.model_range"
             class="font-weight-bold text-center pt-2"
      >
        -
      </b-col>
      <b-col v-if="input.model_range"
             class="pl-0"
      >
        <label :for="v_model_up_to" v-if="show_um_label">Límite</label>
        <b-form-input
          :id="v_model_up_to"
          :name="v_model_up_to"
          type="number"
          step="0.001"
          v-model="input.model_up_to"
          :disabled="readonly"
          @change="vModelUpToVal()"
          data-vv-as=" "
          v-validate="{
            rules: {
              required: input.model_range,
              decimal: 3,
              min_value: ![null, ''].includes(input.model_from) ? (+input.model_from +0.001) : 0,
              max_value: 999
            }
          }"
        />

        <div
          class="text-danger span-error small"
          v-text="errors.first(v_model_error_up_to)"
        />
      </b-col>
      <b-col cols="4" v-if="um_list.length !== 0">
        <label :for="v_model_um" v-if="show_um_label">Unidad de medida <span v-if="required" style="color: red; padding-right: 0.5em">(*)</span></label>
        <el-select :id="v_model_um"
                   :name="v_model_um"
                   v-model="input.model_um"
                   placeholder=" "
                   size="small"
                   @change="idUm()"
                   data-vv-as=" "
                   v-validate="{
                     rules: {
                       required: true
                     }
                   }"
        >
          <el-option v-for="item in um_list"
                     :key="item.id"
                     :label="item.lista"
                     :value="item.id"
          />
        </el-select>
      </b-col>
    </b-row>
    <span class="text-danger span-error small"
          v-text="error_binput"
    />
  </b-form-group>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

export default {
  name: "BInputUm",
  props: [
    'bv_class',
    'parentState',
    'input_text',
    'required',
    'readonly',
    'show_um_label',
    'v_validate',
    'v_model_range',
    'v_model',
    'v_model_up_to',
    'v_model_um',
    'v_model_error',
    'v_model_error_up_to',
    'um_type',
    'values'
  ],
  data() {
    return {
      form_loaded: false,
      disabled_range: false,
    };
  },
  async created() {
    if (this.um_type !== null) {
      const um_codes = [
        'PRESEN',
        'UTEMP',
        'UPRES',
        'UVISC',
        'DL50',
        'CL50',
        'CE50',
        'IC50',
        'uniden',
        'CAPA',
        'ANIM',
        'TCC-af',
      ];
      await this.obtenerUnidadesDeMedida(um_codes);

      // Deshabilitar rango de valores
      if (this.v_model_range === undefined || this.v_model_range === null || this.v_model_range === '') {
        this.disabled_range = true;
      }
    }
  },
  methods: {
    async setValues(model, value) {
      let parentState = this.parentState;
      const data = {
        module: 'fds_productos',
        parent: parentState,
        child: model,
        value: value,
      };
      await this.stateChildValue(data);
    },
    rangoValores() {
      if (!this.disabled_range) {
        this.setValues(this.v_model_range, this.input.model_range);
      }
    },
    idUm() {
      this.setValues(this.v_model_um, this.input.model_um);
    },
    vModelVal() {
      this.setValues(this.v_model, this.input.model_from);
    },
    vModelUpToVal() {
      this.setValues(this.v_model_up_to, this.input.model_up_to);
    },
    ...mapMutations('binputum', [
      'setParentState'
    ]),
    ...mapActions('binputum', [
      'stateChildValue',
      'obtenerUnidadesDeMedida',
      'filtrarUnidadesMedida'
    ]),
  },
  computed: {
    input() {
      let dataInput = {
        model_range: null,
        model_from: null,
        model_up_to: null,
        model_um: null,
      };

      if (this.values !== undefined && this.values !== null) {
        let value = this.values;
        dataInput.model_range = value[this.v_model_range];
        dataInput.model_from = value[this.v_model];
        dataInput.model_up_to = value[this.v_model_up_to];
        dataInput.model_um = value[this.v_model_um];
      }

      return dataInput;
    },
    um_list() {
      if (this.unidades_medida[this.um_type] !== undefined) {
        return this.unidades_medida[this.um_type];
      }
      return [];
    },
    error_binput() {
      let formattedError = '';
      if (this.error[this.v_model] !== undefined) {
        formattedError += this.error[this.v_model];
      }
      if (this.error[this.v_model_um] !== undefined) {
        formattedError += this.error[this.v_model_um];
      }
      return formattedError;
    },
    ...mapState('binputum', [
      'unidades_medida',
      'unidades_medida_cargadas'
    ]),
    ...mapState('fds_productos',[
      'error'
    ]),
  },
  watch: {
    'um_type'() {
      this.setValues(this.v_model_um, null);
    },
    'input.model_range'(value) {
      if (!this.disabled_range) {
        this.setValues(this.v_model_range, value);
      }
    },
    'input.model_from'(value) {
      this.setValues(this.v_model, value);
    },
    'input.model_up_to'(value) {
      if (!this.disabled_range) {
        this.setValues(this.v_model_up_to, value);
      }
    },
    'input.model_um'(value) {
      this.setValues(this.v_model_um, value);
    },
    /*'values'(value){
      if (value !== undefined && value.length !== 0 && this.form_loaded === false) {
        this.input.model_range = value[this.v_model_range];
        this.input.model_from = value[this.v_model];
        this.input.model_up_to = value[this.v_model_up_to];
        this.input.model_um = value[this.v_model_um];
        this.form_loaded = true;
      } else {
        this.input.model_range = null;
        this.input.model_from = null;
        this.input.model_up_to = null;
        this.input.model_um = null;
        this.form_loaded = false;
      }
    }*/
  }
}
</script>

<style scoped>

</style>
